import type { SearchApiRedirectUserData, SearchApiUserData } from '~/types/searchApi'

type ResultsWithUserData = {
    userData?: SearchApiUserData[]
} | null | undefined

/**
 * Picks the redirect out of a `multi-search` result's `userData`, or `null`.
 * `unknown` because its callers hold the same payload under different types — a
 * `SearchResults` in SearchQueryRedirectMeili, a slot prop in SearchMeili.
 */
export function findSearchApiRedirect(results: unknown): SearchApiRedirectUserData | null {
    const userData = (results as ResultsWithUserData)?.userData

    if (!Array.isArray(userData)) {
        return null
    }

    const redirect = userData.find(
        (entry): entry is SearchApiRedirectUserData => entry?.type === 'redirect',
    )

    return redirect?.url ? redirect : null
}
